export enum EMenuProfile {
  Name,
  Email,
  PhoneNumber,
  Gender,
  ChangePassword,
  Logout
}
